import {observer} from "mobx-react-lite";
import React, {useEffect} from "react";
import {Box, Typography, Button} from "@mui/material";
import {$sidebar} from "store/sidebar";
import {$modals} from "../../store/modals";
import FastOrderDiscountsTable from "./table";
import CreateDiscountModal from "./modals/createDiscountModal";
import EditDiscountModal from "./modals/editDiscountModal";
import DeleteDiscountModal from "./modals/deleteDiscountModal";

const FastOrderLinks = observer(() => {
  useEffect(() => {
    $sidebar.setPageTitle("Скидки быстрых заказов");
  }, []);

  const handleCreateDiscount = () => {
    $modals.createFastOrderDiscount.show();
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography
          variant="h4"
          component="div"
        >
          Скидки быстрых заказов
        </Typography>
        <Button
          variant="contained"
          onClick={handleCreateDiscount}
        >
          Создать скидку
        </Button>
      </Box>
      
      <FastOrderDiscountsTable />

      {/* Модальные окна */}
      <CreateDiscountModal />
      <EditDiscountModal />
      <DeleteDiscountModal />
    </>
  );
});

export default FastOrderLinks;
